import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Popup } from 'ng2-opd-popup';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AdminService } from '../../services/admin';
declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Evaluation effectué. Merci. ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Agent inscrit. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-evaluation-enligne',
  templateUrl: './evaluation-enligne.component.html',
  styleUrls: ['./evaluation-enligne.component.scss']
})
export class EvaluationEnligneComponent implements OnInit {
  pdfSrc: any;
  pdfSrc_m: string = "assets/file/fie.pdf";
   pdfSrc_a: string = "assets/file/fie_a.pdf";
     pdfSrc_p: string = "assets/file/fie_p.pdf";
  name: string = ""
  forname: string = ""
  specialite: string = "";
  image_path: any = "medecin_e.jpg"
  diplome: string = "Médecin diplômé d'Etat"
  diplome_spec: string = "Médecin spécialiste diplômé d'Etat"

  @ViewChild('popup5') popup5: Popup;
  @ViewChild('popuppharmacie') popuppharmacie: Popup;  
  @ViewChild('popupaccuiel') popupaccuiel: Popup;
  @ViewChild('popupchoixmed') popupchoixmed: Popup;
  
  
  id: any;
  onm: any;
  listeMedecin: any;

  constructor(public activatedRoute: ActivatedRoute,private adminService: AdminService,  ) {
    this.id = activatedRoute.snapshot.params['id'];
    console.log("evaluation en ligne" + this.id);
    if (this.id == -11) {
      //Accueil Anosy
      this.image_path = "accueil_e.jpg";
      this.forname = "Accueil Anosy";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -22) {
      //Accueil Tsiazotafo
      this.image_path = "accueil_e.jpg"
      this.forname = "Accueil Tsiazotafo";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -33) {
      //Accueil Antaninarenina
      this.image_path = "accueil_e.jpg"
      this.forname = "Accueil Antaninarenina";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -111) {
      //Pharmacie Anosy
      this.image_path = "pharmacie_e.jpg"
      this.forname = "Pharmacie Anosy";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -222) {
      //Pharmacie Tsiazotafo
      this.image_path = "pharmacie_e.jpg"
      this.forname = "Pharmacie Tsiazotafo";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -333) {
      //Pharmacie Antaninarenina
      this.image_path = "pharmacie_e.jpg"
      this.forname = "Pharmacie Antaninarenina";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    }

    if (this.id == 92) {
      //Dr Vony
      this.forname = " Dr Vony",
        this.specialite = "Urgences Pédiatriques, Allergologue";
      this.image_path = "dr_vony.jpg"
      this.diplome = this.diplome_spec
      this.onm = "ONM: 02 12 22 31 410 8450"

    } if (this.id == 47) {
      //Dr Imisa 
      this.forname = "Dr Imisa",
        this.specialite = "Neuro-psychiatre";
      this.image_path = "dr_imisa.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 11 22 31 411 5964";

    }
    if (this.id == 27) {
      //Dr Rina
      this.forname = "Dr Rina";
      this.specialite = "Généraliste";
      this.image_path = "dr_rina.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 04 11 21 31 410 9707 ";
    }
    if (this.id == 60) {
      //Dr Onja
      this.forname = "Dr Onja";
      this.specialite = "Assistant Urgentiste";
      this.image_path = "dr_onja.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 03 11 21 31 410 8627 "
    }
    if (this.id == 70) {
      //Dr Ifano
      this.forname = "Dr Ifano";
      this.specialite = "Médecin interne";
      this.image_path = "dr_ifano.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 6586"

    }
    if (this.id == 24) {
      //Dr Hary
      this.forname = "Dr Hary";
      this.specialite = "Généraliste";
      this.image_path = "dr_hary.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 7001"

    } if (this.id == 67) {
      //Dr Manohy
      this.forname = "Dr Manohy";
      this.specialite = "Echographiste";
      this.image_path = "dr_manohy_1.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 13 22 31 410 0817"

    } if (this.id == 68) {
      //Dr Violety
      this.forname = "Dr Violety";
      this.specialite = "Echographiste";
      this.image_path = "dr_violety.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 13 22 31 410 0817"

    } if (this.id == 69) {
      //Dr Fanja
      this.forname = "Dr Fanja";
      this.specialite = "Cardiologue";
      this.image_path = "dr_fanja_3.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 11 22 31 410 6191"

    } if (this.id == 25) {
      //Dr Lanto
      this.forname = "Dr Lanto";
      this.specialite = "Généraliste";
      this.image_path = "dr_lanto.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 3461"
    }
    if (this.id == 26) {
      //Dr Laingo
      this.forname = "Dr Laingo";
      this.specialite = "Généraliste";
      this.image_path = "dr_laingo.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 9687"
    }
    if (this.id == 71) {
      //Dr Andry
      this.forname = "Dr Andry";
      this.specialite = "Anesthésiste-réanimateur";
      this.image_path = "dr_andry.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 2459"


    } if (this.id == 61) {
      //Dr Rija
      this.forname = "Dr Rija";
      this.specialite = "PÉDIATRE";
      this.image_path = "dr_rija.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 7863"

    }
    if (this.id == 62) {
      //Dr Mamy
      this.forname = "Dr Mamy";
      this.specialite = "ASSISTANTE PÉDIATRE";
      this.image_path = "dr_mamy.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 4443"

    }
    if (this.id == 63) {
      //Dr Tiana
      this.forname = "Dr Tiana";
      this.specialite = "Oto-rhino-laryngologie Allergologue";
      this.image_path = "dr_tina.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 04 11 22 31 410 7058"

    }
    if (this.id == 64) {
      //Dr Nivo
      this.forname = "Dr Nivo";
      this.specialite = "Ophtalmologue";
      this.image_path = "dr_nivo.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 13 22 31 410 3884"

    }

    if (this.id == 65) {
      //Dr Koloina
      this.forname = "Dr Koloina";
      this.specialite = "Gynécologue-Obstétricienne";
      this.image_path = "dr_koloina.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 22 31 410 6301"
    }
    if (this.id == 66) {
      //Dr Hery
      this.forname = "Dr Hery";
      this.specialite = "Dentiste";
      this.image_path = "dr_hery.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 700"
    }

    if (this.id == 56) {
      //Dr Roland
      this.forname = "Dr RANAIVO Roland";
      this.specialite = "Pédiatre";
      this.image_path = "dr_roland.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 3019"
    }
    if (this.id == 94) {
      //Dr Norolala
      this.forname = " Dr Norolala";
      this.specialite = "Géneraliste";
      this.image_path = "dr_norolala.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 6744"
    }
    if (this.id == 100) {
      //Dr Thierry
      this.forname = "Dr Thierry";
      this.specialite = "Biologiste médical";
      this.image_path = "dr_thierry.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 12 21 31 410 7399"
    }

  }

  ngOnInit() {
    this.open2();
  }

  open2(){
    if (this.id == -11 || this.id == -22 || this.id == -33) {
                this.pdfSrc = this.pdfSrc_a    
    } else if (this.id ==  -111 || this.id == -222 || this.id == -333) {
      
       this.pdfSrc = this.pdfSrc_p 
    } else{
       this.pdfSrc = this.pdfSrc_m
    }

  }


  open() {
    if (this.id == -11 || this.id == -22 || this.id == -33) {
      this.popupaccuiel.options = {
        cancleBtnClass: "btn btn-danger",
        confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
        showButtons: true,
        animationDuration: 1.5,
        header: "Ajouter note",
        widthProsentage: 60,
        animation: "fadeInRight",
        confirmBtnContent: "Ajouter",
        cancleBtnContent: "Fermer",
      }
      this.popupaccuiel.show(this.popupaccuiel.options);
    } else if (this.id ==  -111 || this.id == -222 || this.id == -333) {
      this.popuppharmacie.options = {
        cancleBtnClass: "btn btn-danger",
        confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
        showButtons: true,
        animationDuration: 1.5,
        header: "Ajouter note",
        widthProsentage: 60,
        animation: "fadeInRight",
        confirmBtnContent: "Ajouter",
        cancleBtnContent: "Fermer",
      }
      this.popuppharmacie.show(this.popuppharmacie.options);
    } else{
      this.popup5.options = {
        cancleBtnClass: "btn btn-danger",
        confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
        showButtons: true,
        animationDuration: 1.5,
        header: "Ajouter note",
        widthProsentage: 60,
        animation: "fadeInRight",
        confirmBtnContent: "Ajouter",
        cancleBtnContent: "Fermer",
      }

      this.popup5.show(this.popup5.options);
    }

  }

  valide() {
    Swal.fire({
      title: 'FICHE INDIVIDUELLE D’EVALUATION',
      icon: 'info',
      text: '..............Evaluation de Dr...................',
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok, Valider!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        this.popup5.hide();
        success_message2.show();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }

  autreevaluation(){
    this.popupchoixmed.options = {
      cancleBtnClass: "btn btn-danger",
      confirmBtnClass: "btn btn-success",
    color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Evaluation en ligne",
      widthProsentage: 40,
      animation: "fadeInRight",
      confirmBtnContent: "Oui, evaluer",
      cancleBtnContent: "Fermer",
    }
    this.popupchoixmed.show(this.popupchoixmed.options);
    this.getListMedecin();
  }


  getListMedecin(){
    this.adminService.getMedecin("",0,0).subscribe(data=>{
        this.listeMedecin=data;
    },err=>{

    });
  }


  valideChoix(p:any){
    this.id = p;
    this.open2();
    if (this.id == -11) {
      //Accueil Anosy
      this.image_path = "accueil_e.jpg";
      this.forname = "Accueil Anosy";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";

    } if (this.id == -22) {
      //Accueil Tsiazotafo
      this.image_path = "accueil_e.jpg"
      this.forname = "Accueil Tsiazotafo";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -33) {
      //Accueil Antaninarenina
      this.image_path = "accueil_e.jpg"
      this.forname = "Accueil Antaninarenina";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -111) {
      //Pharmacie Anosy
      this.image_path = "pharmacie_e.jpg"
      this.forname = "Pharmacie Anosy";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -222) {
      //Pharmacie Tsiazotafo
      this.image_path = "pharmacie_e.jpg"
      this.forname = "Pharmacie Tsiazotafo";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    } if (this.id == -333) {
      //Pharmacie Antaninarenina
      this.image_path = "pharmacie_e.jpg"
      this.forname = "Pharmacie Antaninarenina";
      this.diplome = "";
      this.specialite = "";
      this.onm = "";
    }

    if (this.id == 92) {
      //Dr Vony

      this.forname = " Dr Vony",
        this.specialite = "Urgences Pédiatriques, Allergologue";
      this.image_path = "dr_vony.jpg"
      this.diplome = this.diplome_spec
      this.onm = "ONM: 02 12 22 31 410 8450"

    } if (this.id == 47) {
      //Dr Imisa 
      this.forname = "Dr Imisa",
        this.specialite = "Neuro-psychiatre";
      this.image_path = "dr_imisa.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 11 22 31 411 5964";

    }
    if (this.id == 27) {
      //Dr Rina
      this.forname = "Dr Rina";
      this.specialite = "Généraliste";
      this.image_path = "dr_rina.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 04 11 21 31 410 9707 ";
    }
    if (this.id == 60) {
      //Dr Onja
      this.forname = "Dr Onja";
      this.specialite = "Assistant Urgentiste";
      this.image_path = "dr_onja.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 03 11 21 31 410 8627 "
    }
    if (this.id == 70) {
      //Dr Ifano
      this.forname = "Dr Ifano";
      this.specialite = "Médecin interne";
      this.image_path = "dr_ifano.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 6586"

    }
    if (this.id == 24) {
      //Dr Hary
      this.forname = "Dr Hary";
      this.specialite = "Généraliste";
      this.image_path = "dr_hary.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 7001"

    } if (this.id == 67) {
      //Dr Manohy
      this.forname = "Dr Manohy";
      this.specialite = "Echographiste";
      this.image_path = "dr_manohy_1.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 13 22 31 410 0817"

    } if (this.id == 68) {
      //Dr Violety
      this.forname = "Dr Violety";
      this.specialite = "Echographiste";
      this.image_path = "dr_violety.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 13 22 31 410 0817"

    } if (this.id == 69) {
      //Dr Fanja
      this.forname = "Dr Fanja";
      this.specialite = "Cardiologue";
      this.image_path = "dr_fanja_3.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 11 22 31 410 6191"

    } if (this.id == 25) {
      //Dr Lanto
      this.forname = "Dr Lanto";
      this.specialite = "Généraliste";
      this.image_path = "dr_lanto.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 3461"
    }
    if (this.id == 26) {
      //Dr Laingo
      this.forname = "Dr Laingo";
      this.specialite = "Généraliste";
      this.image_path = "dr_laingo.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 9687"
    }
    if (this.id == 71) {
      //Dr Andry
      this.forname = "Dr Andry";
      this.specialite = "Anesthésiste-réanimateur";
      this.image_path = "dr_andry.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 2459"


    } if (this.id == 61) {
      //Dr Rija
      this.forname = "Dr Rija";
      this.specialite = "PÉDIATRE";
      this.image_path = "dr_rija.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 7863"

    }
    if (this.id == 62) {
      //Dr Mamy
      this.forname = "Dr Mamy";
      this.specialite = "ASSISTANTE PÉDIATRE";
      this.image_path = "dr_mamy.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 4443"

    }
    if (this.id == 63) {
      //Dr Tiana
      this.forname = "Dr Tiana";
      this.specialite = "Oto-rhino-laryngologie Allergologue";
      this.image_path = "dr_tina.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 04 11 22 31 410 7058"

    }
    if (this.id == 64) {
      //Dr Nivo
      this.forname = "Dr Nivo";
      this.specialite = "Ophtalmologue";
      this.image_path = "dr_nivo.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 13 22 31 410 3884"

    }

    if (this.id == 65) {
      //Dr Koloina
      this.forname = "Dr Koloina";
      this.specialite = "Gynécologue-Obstétricienne";
      this.image_path = "dr_koloina.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 22 31 410 6301"
    }
    if (this.id == 66) {
      //Dr Hery
      this.forname = "Dr Hery";
      this.specialite = "Dentiste";
      this.image_path = "dr_hery.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 700"
    }

    if (this.id == 56) {
      //Dr Roland
      this.forname = "Dr RANAIVO Roland";
      this.specialite = "Pédiatre";
      this.image_path = "dr_roland.PNG";
      this.diplome = this.diplome_spec;
      this.onm = "ONM: 02 12 21 31 410 3019"
    }
    if (this.id == 94) {
      //Dr Norolala
      this.forname = " Dr Norolala";
      this.specialite = "Géneraliste";
      this.image_path = "dr_norolala.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 11 22 31 410 6744"
    }
    if (this.id == 100) {
      //Dr Thierry
      this.forname = "Dr Thierry";
      this.specialite = "Biologiste médical";
      this.image_path = "dr_thierry.PNG";
      this.diplome = this.diplome;
      this.onm = "ONM: 02 12 21 31 410 7399"
    }

    this.popupchoixmed.hide();
  }
  




}
